module.exports = __webpack_public_path__ + "images/feature/two-factor-1-4fe4e58f5b897aa802a100ed8020d76c.jpg";